import { memo } from 'react';
import { EApplicationPGKeys } from 'types';
import { TableCellProps } from '../../../types';
import { defaultHeaderRenderer } from '../../headers';
import { IColumn } from '../../types';
import { UNKNOWN_VALUE } from '../helpers';
import { Flex } from '@chakra-ui/react';

const LeftAlignFormatter = memo(function formatter(cellProps: TableCellProps) {
  return (
    <Flex height="100%" width="100%" flexDirection={'column'}>
      {cellProps.row.courseName || cellProps.row.programme?.courseName || UNKNOWN_VALUE}
    </Flex>
  );
});

export const CourseColumn = (): IColumn => ({
  item: {
    key: EApplicationPGKeys.COURSE_ID,
    name: 'Course name',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(160px, 1.75fr)',
    formatter: LeftAlignFormatter,
    responsive: true,
  },
  visible: () => true,
});
